import axios from 'axios';
import deepParseJson from "utils/deepParseJson";

// Get the user ID from localStorage if it exists
const user_id = localStorage.getItem('user_id') ? JSON.parse(localStorage.getItem('user_id')) : null;

// Create an Axios instance
export const axiosInstance = axios.create({
  headers: user_id ? { user_id: user_id } : {},
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    try {
      const rawPersistData = localStorage.getItem("admin");
      if (rawPersistData) {
        const persistData = deepParseJson(rawPersistData);
        const accessToken = persistData?.auth?.session?.token;

        if (accessToken) {
          config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
      }
    } catch (error) {
      // console.error('Error in request interceptor:', error);

    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 403 errors
axiosInstance.interceptors.response.use(
  (response) => {
    // Return the response if it's successful
    return response;
  },
  (error) => {

    // Check if the error response has a 403 status code
    if (error.response && error.response.status === 403) {
      const user_id = localStorage.getItem('user_id');
      handleLogout();
    }

    return Promise.reject(error);
  }
);

// Logout function
function handleLogout() {
  try {
    // Avoid clearing data and re-redirecting if already on the sign-in page
    if (window.location.pathname === '/sign-in') {
      return;
    }

    // Clear user data from localStorage
    localStorage.removeItem("user_id");
    localStorage.removeItem("admin");
    window.location.href = '/sign-in'; // Update this path as per your application routing
  } catch (error) {
    // console.error('Error in handleLogout:', error);
  }
}
